/**
 * Reducer mappers: Availability
 */

const StockStatus = {
  NO_STOCK: ' - Out of stock',
  LOW_STOCK: ' - Hurry, low stock!',
  LOTS_OF_STOCK: ''
}

const getAvailabilityText = quantity => {
  const available = parseInt(quantity, 10)
  if (available === 0) {
    return StockStatus.NO_STOCK
  }
  if (available >= 0 && available < 6) {
    return StockStatus.LOW_STOCK
  }
  return StockStatus.LOTS_OF_STOCK
}

const mapStateToAvailabilityInfoProps = (state, ownProps) => {
  const { partNumber } = ownProps

  const { availability = {} } = state

  const { data = {}, meta = {} } = availability

  const { requestDone, errorDetail } = meta

  const { quantityAvailable = 0 } = data[partNumber] || {}

  const isAvailable = !requestDone
    ? true // Assume availability until request is done
    : errorDetail
    ? true // Return true on error so customer can still add to trolley
    : quantityAvailable > 0

  return {
    quantity: quantityAvailable,
    isAvailable,
    message: requestDone && !errorDetail ? getAvailabilityText(quantityAvailable) : ''
  }
}

const mapStateToAvailabilityProps = (state = {}, ownProps = {}) => {
  const { availability = {} } = state

  const { meta = {} } = availability

  const { requestDone, errorDetail } = meta

  return {
    status: {
      requestDone,
      errorDetail
    },
    ...mapStateToAvailabilityInfoProps(state, ownProps)
  }
}

export default mapStateToAvailabilityProps
